import Glide from '@glidejs/glide'
export const mainSlider = () => {
  let $mainSlider = document.querySelector('.glide.glide--main-slider')

  if(!$mainSlider) return

  const mainSlider = new Glide($mainSlider, {
    autoplay: 3500,
    hoverpause: false,
    perView: 1,
    type: 'slider'
  }).mount()
}

export const ammenitiesCarousels = () => {
  let $carousels = document.querySelectorAll('.glide.glide--ammenities')

  if(!$carousels.length === 0) return

  $carousels.forEach(($carousel) => {
    new Glide($carousel, {
      perView: 1,
      type: 'slider',
    }).mount()
  })
}

let glideCarousels = []
export const floorCarousels = () => {
  if(glideCarousels.length > 0) {
    for(let i in glideCarousels) {
      glideCarousels[i].destroy()
    }
    glideCarousels = []
  }

  let $carousels = document.querySelectorAll('.active[data-tower] .glide.glide--floor')

  if(!$carousels.length === 0) return

  $carousels.forEach(($carousel) => {
    let glideCarousel = new Glide($carousel, {
      perView: 1,
      type: 'slider',
      focusAt: 'center',
      peek: 350,
      breakpoints: {
        1024: {
          peek: 200
        },
        768: {
          peek: 100
        },
        600: {
          peek: 50
        }
      }
    })

    glideCarousel.on('move.after', (movement) => {
      let $floor = glideCarousel._c.Html.slides[glideCarousel.index],
          url = $floor.getAttribute('data-route'),
          slug = $floor.getAttribute('data-slug'),
          tower = $floor.getAttribute('data-tower')

      $('[appender]').html('<div class="x:center"><i class="x:fs-40 fa fa-spin fa-spinner"></i></div>')
      axios.post(url, {
        slug: slug,
        tower: tower,
      })
      .then((response) => {
        $('[appender]').html(response.data);
      })
      .catch((error) => {
        console.log('Ocurrió un error obteniendo los datos de la torre y piso')
      })
      .then(() => {

      })
    })

    glideCarousel.mount()
    glideCarousels.push(glideCarousel)
  })
}
